function RequestAccess() {
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <iframe
        title="request-access-form"
        src="https://docs.google.com/forms/d/e/1FAIpQLSdJW6Mb9P89gt3fZ-8OfBWwPDUTbYxl98ckdXeYBHbqL2906Q/viewform"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      >
        Loading…
      </iframe>
    </div>
  );
}

export default RequestAccess;
